module.exports = __webpack_public_path__ + "img/core_values-p-500.af79d8ec.png";